<template>
<div class="list">
  <a-list itemLayout="horizontal"
    :dataSource="entitysData.length > defaultLength ? entitysData.slice(0, defaultLength) : entitysData">
    <a-list-item slot="renderItem" slot-scope="item" @click.native="showInfo(item)" style="cursor: pointer">
      <a-row style="width:15%">
        <i :class="item.onlineStatus ? 'icon-online icon-lg' : 'icon-offline icon-lg'">
          <zx-icon type="icon-shoubiao"></zx-icon>
        </i>
      </a-row>
      <a-row style="width:40%;margin-top:7px">
        {{item.entity}}
      </a-row>
      <!-- 是否请假 -->
      <a-row style="width:15%">
        <i v-show="item.isAbsent" :class="item.isAbsent ? 'icon-online icon-lg' : 'icon-offline icon-lg'">
          <zx-icon type="icon-qingjia"></zx-icon>
        </i>
      </a-row>
      <a-row style="width:15%">
        <i :class="item.sn ? 'icon-online icon-lg' : 'icon-offline icon-lg'">
          <zx-icon type="icon-wanbiaobangding"></zx-icon>
        </i>
      </a-row>
      <a-row style="width:15%">
        <i class="icon-alarm icon-lg" v-if="item.alarmNum > 0">
          <zx-icon type="icon-gaojing"></zx-icon>
        </i>
      </a-row>
    </a-list-item>
    <div style="text-align: center;margin:10px">
      <a v-if="entitysData.length > defaultLength" @click="loadMore(entitysData)">{{$t('home.loadMore')}}</a>
    </div>
  </a-list>
</div>
  
</template>
<script>
import bus from '../../bus/bus'
export default {
  props: ['entitysData'],
  data () {
    return {
      defaultLength: 5
    }
  },
  methods: {
    loadMore(entitysData) {
      this.defaultLength += 5
    },
    showInfo(item) {
      bus.$emit('showInfoBox', item)
    }
  },
}
</script>
<style lang="less" scoped>
.list {
  margin-left: 25px;
}
</style>
